// Flex.tsx
import { css } from "@pigment-css/react";
import { clsx } from "clsx";

const baseStyle = css({
  display: "flex",
});

// Static spacing styles for gap
const gapStyles = {
  0: css(({ theme }) => ({ gap: theme.spacing["0"] })),
  1: css(({ theme }) => ({ gap: theme.spacing["1"] })),
  2: css(({ theme }) => ({ gap: theme.spacing["2"] })),
  3: css(({ theme }) => ({ gap: theme.spacing["3"] })),
  4: css(({ theme }) => ({ gap: theme.spacing["4"] })),
  5: css(({ theme }) => ({ gap: theme.spacing["5"] })),
  6: css(({ theme }) => ({ gap: theme.spacing["6"] })),
  7: css(({ theme }) => ({ gap: theme.spacing["7"] })),
  8: css(({ theme }) => ({ gap: theme.spacing["8"] })),
  9: css(({ theme }) => ({ gap: theme.spacing["9"] })),
  10: css(({ theme }) => ({ gap: theme.spacing["10"] })),
};

// Static spacing styles for columnGap
const columnGapStyles = {
  0: css(({ theme }) => ({ columnGap: theme.spacing["0"] })),
  1: css(({ theme }) => ({ columnGap: theme.spacing["1"] })),
  2: css(({ theme }) => ({ columnGap: theme.spacing["2"] })),
  3: css(({ theme }) => ({ columnGap: theme.spacing["3"] })),
  4: css(({ theme }) => ({ columnGap: theme.spacing["4"] })),
  5: css(({ theme }) => ({ columnGap: theme.spacing["5"] })),
  6: css(({ theme }) => ({ columnGap: theme.spacing["6"] })),
  7: css(({ theme }) => ({ columnGap: theme.spacing["7"] })),
  8: css(({ theme }) => ({ columnGap: theme.spacing["8"] })),
  9: css(({ theme }) => ({ columnGap: theme.spacing["9"] })),
  10: css(({ theme }) => ({ columnGap: theme.spacing["10"] })),
};

const directionStyles = {
  row: css({ flexDirection: "row" }),
  column: css({ flexDirection: "column" }),
};

const alignStyles = {
  start: css({ alignItems: "flex-start" }),
  center: css({ alignItems: "center" }),
  end: css({ alignItems: "flex-end" }),
  stretch: css({ alignItems: "stretch" }),
};

const justifyStyles = {
  start: css({ justifyContent: "flex-start" }),
  center: css({ justifyContent: "center" }),
  end: css({ justifyContent: "flex-end" }),
  between: css({ justifyContent: "space-between" }),
};

const wrapStyles = {
  nowrap: css({ flexWrap: "nowrap" }),
  wrap: css({ flexWrap: "wrap" }),
};

export const Flex = ({
  direction = "row",
  gap = 2,
  align,
  justify = "start",
  className,
  children,
  wrap = false,
  columnGap,
  ...props
}: {
  direction?: keyof typeof directionStyles;
  gap?: keyof typeof gapStyles;
  columnGap?: keyof typeof gapStyles;
  align?: keyof typeof alignStyles;
  justify?: keyof typeof justifyStyles;
  wrap?: boolean;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const effectiveAlign = align ?? (direction === "column" ? "stretch" : "center");

  return (
    <div
      className={clsx(
        baseStyle,
        directionStyles[direction],
        gapStyles[gap],
        columnGap && columnGapStyles[columnGap],
        alignStyles[effectiveAlign],
        justifyStyles[justify],
        wrap ? wrapStyles.wrap : wrapStyles.nowrap,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
